// Components
import { Grid } from "@mui/material";
import { Charts } from "./Charts";
import { PathToImprovement } from "./PathToImprovement";
import { useEffect } from "react";

// Hook
import { useAppSelector } from "app/hooks";

// Store
import { getImprovementState } from "store/slice/UI";

// Service
import { insightRegisterEvent } from "services";

const ProjectionBody = (): JSX.Element => {
    const isPathToImprovementVisible = useAppSelector(getImprovementState);

    useEffect(() => {
        const data = async () => {
            try {
                await insightRegisterEvent();
            } catch (error) {
                console.error(error);
            }
        };
        data();
    }, []);

    return (
        <Grid container sx={{ height: "100%" }}>
            {isPathToImprovementVisible && <PathToImprovement />}
            {!isPathToImprovementVisible && <Charts />}
        </Grid>
    );
};

export default ProjectionBody;
